import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// export const userUrl = "olalekansalamiassociates.ourlisting.ng";
export const userUrl = "frelainopatronica.ourlisting.ng";

export function logEnvironment(message?: string) {
  if (typeof window === "undefined") {
    // Running on the server
    console.log(`[Server] ${message || "Running on the server"}`);
  } else {
    // Running on the client
    console.log(`[Client] ${message || "Running on the client"}`);
  }
}
